export default __webpack_public_path__ + "static/media/arrow-down.6a1bb6c9.svg";